import type { Photo } from '@capacitor/camera';

// MOB-05 — SEULE nouveauté du flux de dépôt de preuve de paiement (PAY-16,
// `DepositPaymentProofModal.tsx`) : convertit la `Photo` renvoyée par
// `@capacitor/camera` (une URI `webPath`, jamais un `File`) en un `File`
// standard AVANT tout appel à `submitPaymentProof()`
// (`packages/api-client/src/paymentProof.ts`) — cette fonction et son
// résultat sont la seule chose qui change ; la route backend et
// `submitPaymentProof()` eux-mêmes restent STRICTEMENT inchangés, exactement
// comme pour un fichier choisi via l'`<input type="file">` déjà existant.
const MIME_TYPE_BY_CAPACITOR_FORMAT: Record<string, string> = {
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
};

export async function capacitorPhotoToFile(photo: Photo, filenamePrefix: string): Promise<File> {
  if (!photo.webPath) {
    throw new Error('capacitorPhotoToFile: photo.webPath manquant');
  }
  const response = await fetch(photo.webPath);
  const blob = await response.blob();
  // Repli sur le type MIME du blob lui-même si `photo.format` est une valeur
  // inattendue — jamais un type MIME devinée au hasard, `blob.type` reflète
  // ce que le WebView natif a réellement produit.
  const mimeType = MIME_TYPE_BY_CAPACITOR_FORMAT[photo.format] ?? (blob.type || 'image/jpeg');
  const extension = mimeType === 'image/png' ? 'png' : 'jpg';
  return new File([blob], `${filenamePrefix}.${extension}`, { type: mimeType });
}
